module.exports = __webpack_public_path__ + "img/d.cb166cba.jpg";